/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mindful_SpaceInputs */

const en_mindful_space = /** @type {(inputs: Mindful_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enjoy various Soundscape`)
};

const ar_mindful_space = /** @type {(inputs: Mindful_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استمتع بمجموعة متنوعة من منظر صوتي`)
};

const de_mindful_space = /** @type {(inputs: Mindful_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genießen Sie verschiedene Klanglandschaft`)
};

const es_mindful_space = /** @type {(inputs: Mindful_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disfruta de diversos paisajes sonoros`)
};

const fr_mindful_space = /** @type {(inputs: Mindful_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profitez d'une multitude de Paysages sonores`)
};

const it_mindful_space = /** @type {(inputs: Mindful_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goditi vari Soundscape`)
};

const ja_mindful_space = /** @type {(inputs: Mindful_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`さまざまなサウンドスケープ`)
};

const ko_mindful_space = /** @type {(inputs: Mindful_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다양한 사운드스케이프 지원`)
};

const pt_br_mindful_space = /** @type {(inputs: Mindful_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aproveite várias paisagens sonoras`)
};

const ru_mindful_space = /** @type {(inputs: Mindful_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наслаждайтесь различными звуковыми ландшафтами`)
};

const th_mindful_space = /** @type {(inputs: Mindful_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพลิดเพลินกับทัศนียภาพแห่งเสียงที่หลากหลาย`)
};

const tr_mindful_space = /** @type {(inputs: Mindful_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çeşitli ses manzaralarının tadını çıkar`)
};

const zh_cn_mindful_space = /** @type {(inputs: Mindful_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`享受更多声音场景`)
};

const zh_tw_mindful_space = /** @type {(inputs: Mindful_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`享受更多聲音場景`)
};

/**
* | output |
* | --- |
* | "Enjoy various Soundscape" |
*
* @param {Mindful_SpaceInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const mindful_space = /** @type {((inputs?: Mindful_SpaceInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mindful_SpaceInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mindful_space(inputs)
	if (locale === "ar") return ar_mindful_space(inputs)
	if (locale === "de") return de_mindful_space(inputs)
	if (locale === "es") return es_mindful_space(inputs)
	if (locale === "fr") return fr_mindful_space(inputs)
	if (locale === "it") return it_mindful_space(inputs)
	if (locale === "ja") return ja_mindful_space(inputs)
	if (locale === "ko") return ko_mindful_space(inputs)
	if (locale === "pt_br") return pt_br_mindful_space(inputs)
	if (locale === "ru") return ru_mindful_space(inputs)
	if (locale === "th") return th_mindful_space(inputs)
	if (locale === "tr") return tr_mindful_space(inputs)
	if (locale === "zh_cn") return zh_cn_mindful_space(inputs)
	return zh_tw_mindful_space(inputs)
});